import { render, staticRenderFns } from "./CommonCategoryTree.vue?vue&type=template&id=c20a9b98&scoped=true&"
import script from "./CommonCategoryTree.vue?vue&type=script&lang=js&"
export * from "./CommonCategoryTree.vue?vue&type=script&lang=js&"
import style0 from "./CommonCategoryTree.vue?vue&type=style&index=0&id=c20a9b98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20a9b98",
  null
  
)

export default component.exports